import React, { useRef } from 'react'
import LocationFilter from 'components/LocationFilter'
import MiniModal from 'components/MiniModal'
import SkillsFilter from 'components/SkillsFilter'
import RolesFilter from 'components/RolesFilter'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import styles from '../FilterPopup/styles'
import { useFilters } from 'clientHelpers/context/filtersContext'

const FilterPopup = ({
  open,
  filterType,
  label,
  placeholder,
  value,
  closeFilter,
  onToggle,
  dropdownValues,
  skillsValidationError,
  validateSkillsSelected,
  onClickOutsideFilter,
}) => {
  const { setFilterValues, ...filters } = useFilters()
  const { locations, roles, skills } = filters
  const triggerRef = useRef()

  return (
    <MiniModal
      open={open}
      sticky={true}
      placement="left"
      size="small"
      className={styles.modal}
      onClickOutside={onClickOutsideFilter}
      triggerRef={triggerRef}
      trigger={
        <div className={styles.filterBlock}>
          <label className={styles.label}>{label}</label>
          <div className={cx(styles.filterInputWrapper, skillsValidationError && styles.error)}>
            <button ref={triggerRef} className={cx(styles.filterInput, value && styles.filterInputFilled)}>
              {value || placeholder}
            </button>
          </div>
          {skillsValidationError && (
            <small className={styles.errorMessage} role="alert">
              You already selected 3 skills.
            </small>
          )}
        </div>
      }
      onToggle={onToggle}
      closeModal={closeFilter}>
      {/* Location Filter */}
      {filterType === 'location' && (
        <LocationFilter
          locations={dropdownValues}
          closeFilter={closeFilter}
          onApply={updatedLocations => {
            setFilterValues({
              locations: updatedLocations,
            })
          }}
          filterValues={locations}
        />
      )}

      {/* Skills Filter */}

      {filterType === 'skills' && (
        <SkillsFilter
          skills={dropdownValues}
          closeFilter={closeFilter}
          onApply={updatedSkills => {
            setFilterValues({
              skills: updatedSkills,
            })
          }}
          filterValues={skills}
          validateSkillsSelected={validateSkillsSelected}
        />
      )}

      {/* Roles Filter */}

      {filterType === 'roles' && (
        <RolesFilter
          roles={dropdownValues}
          closeFilter={closeFilter}
          onApply={updatedRoles => {
            setFilterValues({
              roles: updatedRoles,
            })
          }}
          filterValues={roles}
        />
      )}
    </MiniModal>
  )
}

FilterPopup.propTypes = {
  filterType: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  validateSkillsSelected: PropTypes.func,
  skillsValidationError: PropTypes.bool,
  closeFilter: PropTypes.func,
  dropdownValues: PropTypes.array,
  onClickOutsideFilter: PropTypes.func,
}

export default FilterPopup
